import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DEFAULT_SIZE_ID } from '../../../models/organization.model';
import { Helpers } from 'app/helpers/helpers';
import { ICartModifier } from 'app/models/cart.model';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  selector: 'app-multiple-select[modifier][groupIsMaxFull][productSizeId]',
  templateUrl: './multiple-select.component.html',
  styleUrls: ['./multiple-select.component.scss']
})
export class MultipleSelectComponent implements OnInit{

  @Input() modifier: ICartModifier;
  @Output() modifierChange = new EventEmitter<ICartModifier>();
  @Input() groupIsMaxFull: boolean;
  @Output() notifyChange: EventEmitter<any> = new EventEmitter();
  // TODO убрать null когда придёт время
  @Input() productSizeId: string | null = DEFAULT_SIZE_ID;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.modifier.calculatedPrice = Helpers.calculatePriceModifier(this.modifier, this.productSizeId);
  }
  increase(): void {
    this.modifier.selectedQuantity++;
    this.notifyChange.emit();
  }

  decrease(): void {
    this.modifier.selectedQuantity--;
    this.notifyChange.emit();
  }

  getName(modifier: ICartModifier) {
    let resultName = modifier.name;

    if (modifier.minAmount){
      resultName = `${resultName}, ${this.translateService.instant('MIN')}:${modifier.minAmount}`;
    }

    if (modifier.maxAmount){
      resultName = `${resultName},  ${this.translateService.instant('MAX')}:${modifier.maxAmount}`;
    }

    return resultName;
  }
}
